module.exports = __webpack_public_path__ + "static/media/measurementTile.8bad15ec.jpg";